import { Locale } from '@op/opds.opux';
import { APP_NAME } from '../common';

export const getLocale = (): Locale => {
  const portalLocale = (document.documentElement.getAttribute('lang') || 'fi').substring(0, 2).toLowerCase();

  return portalLocale as Locale;
};

export const cleanSessionStorage = () => {
  sessionStorage.removeItem(`${APP_NAME}-cardPoints`);
  sessionStorage.removeItem(`${APP_NAME}-cardSelectorToolState`);
  sessionStorage.removeItem(`${APP_NAME}-age`);
  sessionStorage.removeItem(`${APP_NAME}-recommendations`);
};

// Returns true if current time is before the time specified in argument.
export const isBefore = (date: Date): boolean => {
  const now = new Date();
  if (now.getTime() <= date.getTime()) return true;
  else return false;
};

export const formatPrice = (price: string): string => {
  if (getLocale() === 'en') {
    price = price.replace(',', '.');
  } else {
    price = price.replace('.', ',');
  }
  return handleTrailingZeros(price);
};

// Replaces text's <price> placeholder with given price and returns formatted text.
// Takes language into account.
const formatPriceWithText = (msg: string = '', prices: string[] | string = ''): string => {
  if (!Array.isArray(prices)) {
    prices = [prices];
  }
  if (getLocale() === 'en') {
    prices = prices.map((price) => price.replace(',', '.'));
  } else {
    prices = prices.map((price) => price.replace('.', ','));
  }
  prices.forEach((price) => {
    msg = msg.replace('<price>', handleTrailingZeros(price));
  });
  return msg;
};

const handleTrailingZeros = (price: string): string => {
  let trailingPart = '';
  let separator = ',';

  if (price.includes(',')) separator = ',';
  else if (price.includes('.')) separator = '.';

  if (price.includes(separator)) {
    trailingPart = price.slice(price.indexOf(separator) + 1);
  }

  if (trailingPart.length === 1 && trailingPart[0] !== '0') {
    price = price + '0';
  } else if (trailingPart.length === 1 && trailingPart === '0') {
    price = price.substring(0, price.indexOf(separator));
  } else if (trailingPart.length === 2 && trailingPart[0] === '0' && trailingPart[1] === '0') {
    price = price.substring(0, price.indexOf(separator));
  }
  return price;
};

export default formatPriceWithText;
